import axios from "axios";
import API from "../api";
import { createFilters, updateTabs } from "../utils/module-helper";
import { resolve } from "path";
import { rejects } from "assert";

function filteredTabs(filterString) {
  return axios.get(
    `${API.BASE_URL}${API.TABS}?${filterString}`,
    API.RequestHeaders()
  );
}

export const TabsModule = {
  state: {
    allTabs: [],
    openTabs: [],
    openActiveTabs: [],
    activeTabs: [],
    isRequesting: false,
    errored: false,
    error: "",
    paymentTypes: [],
  },
  actions: {
    getAllOpenTabs({ commit }) {
      commit("openTabsRequest");
      return filteredTabs(createFilters({ is_open: 1 }))
        .then((response) => {
          if (response.status === 200) {
            commit("openTabsSuccess", response.data);
            return response.data.original;
          }
        })
        .catch((error) => {
          commit("openTabsError", error);
        });
    },

    getAllActiveTabs({ commit }) {
      commit("activeTabsRequest");
      return filteredTabs(createFilters({ is_active: 1 }))
        .then((response) => {
          if (response.status === 200) {
            commit("activeTabsSuccess", response.data);
            return response.data.original;
          }
        })
        .catch((error) => {
          commit("activeTabsError", error);
        });
    },

    getAllOpenActiveTabs({ commit }) {
      commit("openActiveTabsRequest");
      return filteredTabs(createFilters({ is_active: 1, is_open: 1 }))
        .then((response) => {
          if (response.status === 200) {
            commit("openActiveTabsSuccess", response.data);
            return response.data.original;
          }
        })
        .catch((error) => {
          commit("openActiveTabsError", error);
        });
    },

    fetchAllTabs({ commit }) {
      commit("allTabsRequest");
      return axios
        .get(`${API.BASE_URL}${API.TABS}`, API.RequestHeaders())
        .then((response) => {
          if (response.status === 200) {
            commit("allTabsSuccess", response.data);
            return response.data.original;
          }
        })
        .catch((error) => {
          commit("allTabsError", error);
        });
    },

    getTab({ commit }, tabId) {
      commit("getTabRequest");
      return axios
        .get(`${API.BASE_URL}${API.TABS}/${tabId}`, API.RequestHeaders())
        .then((response) => {
          if (response.status === 200) {
            commit("getTabSuccess", response.data);
            return response.data;
          }
        })
        .catch((error) => {
          commit("getTabError", error);
        });
    },

    createTab({ commit }, newTab) {
      commit("createTabRequest");
      return axios
        .post(`${API.BASE_URL}${API.TABS}`, newTab, API.RequestHeaders())
        .then((response) => {
          if (response.status === 201) {
            commit("createTabSuccess", response.data.original);
            return response.data.original;
          }
        })
        .catch((error) => {
          commit("createTabError", error);
        });
    },

    closeTab({ commit }, tabId) {
      commit("closeTabRequest");
      return axios
        .put(
          `${API.BASE_URL}${API.TABS}/${tabId}`,
          { is_open: 0 },
          API.RequestHeaders()
        )
        .then((response) => {
          if (response.status === 200) {
            commit("closeTabSuccess", response.data.original);
            return response.data.original;
          }
        })
        .catch((error) => {
          commit("closeTabError", error);
        });
    },

    fetchPaymentTypes({ commit }) {
      commit("getModifiersRequest");
      return axios
        .get(`${API.BASE_URL}${API.TABS}${API.MODIFIERS}`, API.RequestHeaders())
        .then((response) => {
          if (response.status === 200) {
            commit("getModifiersSuccess", response.data);
            return response.data;
          }
        })
        .catch((error) => {
          commit("getModifiersError", error);
        });
    },

    getFilteredTab({ commit }, tabData) {
      commit("getTabRequest");
      const filterString = createFilters(tabData);
      return axios
        .get(`${API.BASE_URL}${API.TABS}?${filterString}`, API.RequestHeaders())
        .then((response) => {
          if (response.status === 200) {
            commit("getTabSuccess", response.data);
            if (Array.isArray(response.data) && response.data.length > 0) {
              return response.data[0];
            } else {
              console.warn("Empty or invalid response format for tab data");
              return {};
            }
          }
        })
        .catch((error) => {
          commit("getTabError", error);
          throw error;
        });
    },

    addPayment({ commit, dispatch }, payment) {
      commit("addPaymentRequest");

      const modifier = payment;
      const { guest_id, tab_id } = modifier;

      delete modifier.guest_id;

      let request_uri = `${API.BASE_URL}${API.GUESTS}/${guest_id}${API.TABS}/${tab_id}${API.MODIFIERS}`;

      return new Promise((resolve, reject) => {
        return axios
          .post(request_uri, modifier, API.RequestHeaders())
          .then((response) => {
            if (response.status === 201) {
              dispatch("getTab", tab_id).then((updatedTab) => {
                commit("addPaymentSuccess", updatedTab);
                resolve(updatedTab);
              });
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            commit("addPaymentError", error);
            reject(error);
          });
      });
    },

    addTabAdjustment({ dispatch }, payment) {
      //for now, gratuity and refunds act like payments in a API manner
      return dispatch("addPayment", payment);
    },

    addTabCardHold({ commit }, payload) {
      let request_uri = `${API.BASE_URL}/tabmodifiers/card-hold`;

      return new Promise((resolve, reject) => {
        return axios
          .post(request_uri, payload, API.RequestHeaders())
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    addTabItem({ commit, dispatch }, tabItem) {
      commit("tabItemRequest");
      return new Promise((resolve, reject) => {
        axios
          .post(`${API.BASE_URL}${API.TABITEMS}`, tabItem, API.RequestHeaders())
          .then((response) => {
            if (response.status === 201) {
              return dispatch("getTab", tabItem.tab_id).then((updatedTab) => {
                commit("tabItemSuccess", updatedTab);
                resolve(updatedTab);
              });
            } else {
              reject();
            }
          })
          .catch((error) => {
            commit("tabItemError", error);
            reject(error);
          });
      });
    },

    deleteTabItem({ commit, dispatch }, tabItem) {
      commit("removeTabItemRequest");
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `${API.BASE_URL}${API.TABITEMS}/${tabItem.id}`,
            API.RequestHeaders()
          )
          .then((response) => {
            if (response.status === 200) {
              return dispatch("getTab", tabItem.tab_id).then((updatedTab) => {
                commit("removeTabItemSuccess", updatedTab);
                resolve(updatedTab);
              });
            } else {
              reject();
            }
          })
          .catch((error) => {
            commit("removeTabItemError", error);
            reject(error);
          });
      });
    },
  },

  mutations: {
    openActiveTabsRequest(state) {
      state.isRequesting = true;
    },
    openActiveTabsSuccess(state, payload) {
      state.openActiveTabs = payload;
      state.isRequesting = false;
    },
    openActiveTabsError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    openTabsRequest(state) {
      state.isRequesting = true;
    },
    openTabsSuccess(state, payload) {
      state.openTabs = payload;
      state.isRequesting = false;
    },
    openTabsError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    activeTabsRequest(state) {
      state.isRequesting = true;
    },
    activeTabsSuccess(state, payload) {
      state.activeTabs = payload;
      state.isRequesting = false;
    },
    activeTabsError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    allTabsRequest(state) {
      state.isRequesting = true;
    },
    allTabsSuccess(state, payload) {
      state.allTabs = payload;
      state.isRequesting = false;
    },
    allTabsError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    getTabRequest(state) {
      state.isRequesting = true;
    },
    getTabSuccess(state) {
      state.isRequesting = false;
    },
    getTabError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    createTabRequest(state) {
      state.isRequesting = true;
    },
    createTabSuccess(state, payload) {
      state.openTabs.push(payload);
      state.openActiveTabs.push(payload);
      state.isRequesting = false;
    },
    createTabError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    closeTabRequest(state) {
      state.isRequesting = true;
    },
    closeTabSuccess(state, payload) {
      state.openTabs = state.openTabs.filter((tab) => tab.id !== payload.id);
      state.openActiveTabs = state.openActiveTabs.filter(
        (tab) => tab.id !== payload.id
      );
      state.isRequesting = false;
    },
    closeTabError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    getModifiersRequest(state) {
      state.isRequesting = true;
    },
    getModifiersSuccess(state, modifiers) {
      state.paymentTypes = modifiers;
      state.isRequesting = false;
    },
    getModifiersError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    addPaymentRequest(state) {
      state.isRequesting = true;
    },
    addPaymentSuccess(state, updatedTab) {
      state.isRequesting = false;
      updateTabs(state, updatedTab);
    },
    addPaymentError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    tabItemRequest(state) {
      state.isRequesting = true;
    },
    tabItemSuccess(state, updatedTab) {
      state.isRequesting = false;
      updateTabs(state, updatedTab);
    },
    tabItemError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    removeTabItemRequest(state) {
      state.isRequesting = true;
    },
    removeTabItemSuccess(state, updatedTab) {
      state.isRequesting = false;
      updateTabs(state, updatedTab);
    },
    removeTabItemError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
  },
  getters: {
    getOpenTabs(state) {
      return state.openTabs;
    },
    getOpenActiveTabs(state) {
      return state.openActiveTabs;
    },
    getActiveTabs(state) {
      return state.activeTabs;
    },
    getAllTabs(state) {
      return state.allTabs;
    },
    getAllWalkinTabs(state) {
      return state.allTabs.filter((tab) => tab.guest_id === null);
    },
    getPaymentTypes(state) {
      return state.paymentTypes;
    },
  },
};
